import React from "react";
import { Helmet } from "react-helmet-async";
import { useI18n, LANGS } from "../i18n";

const SITE = "https://www.hrdmimarlik.com";
const OG_IMAGE = `${SITE}/match/hero.jpg`;
const OG_LOCALE = { en: "en_GB", fi: "fi_FI", tr: "tr_TR", es: "es_ES" };

export default function Seo({ path = "/", title, description, image, type = "website", jsonLd }) {
  const { lang } = useI18n();
  const url = `${SITE}${path}`;
  const full = `${title} | HRD Architecture`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {LANGS.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={`${url}?lang=${l}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="HRD Architecture" />
      <meta property="og:locale" content={OG_LOCALE[lang] || "en_GB"} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image || OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || OG_IMAGE} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "HRD Architecture",
  alternateName: "HRD Mimarlık",
  url: SITE,
  logo: `${SITE}/match/hero.jpg`,
  foundingDate: "2009",
  description:
    "Parametric 3D wood wall panels, CNC wood cladding and acoustic surface systems, produced between Helsinki (Finland) and Istanbul (Türkiye).",
  address: [
    {
      "@type": "PostalAddress",
            addressLocality: "Helsinki",
      addressCountry: "FI",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "Perpa Ticaret Merkezi B Blok Kat: 11 No: 1719, Okmeydanı",
      addressLocality: "İstanbul",
      addressCountry: "TR",
    },
  ],
  email: "info@hrdmimarlik.com",
  telephone: "+90 212 220 76 16",
  sameAs: ["https://www.hrdarchitecture.com"],
};

export { SITE };
